<template>
    <div class="flex items-end flex-col">
        <button
            :data-test="`report-${reviewId}`"
            @click="report"
            type="button"
            class="relative inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 focus:outline-none"
        >
            <ExclamationIcon class="h-5 w-5 mr-2" aria-hidden="true" />
            <span>Report</span>
        </button>

        <p
            :class="[
                message.type === 'success'
                    ? 'text-nutreance-green'
                    : 'text-red-600',
                'text-right ml-2',
            ]"
            v-if="message.message"
        >
            {{ message.message }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { ExclamationIcon } from "@heroicons/vue/solid";
import { reportReview } from "../../api/reviews";

const props = defineProps<{
    reviewId: number;
}>();

const message = reactive<{ type: string | null; message: string | null }>({
    type: null,
    message: null,
});

function report() {
    reportReview(props.reviewId)
        .then((data) => {
            message.type = "success";
            message.message = data.message;
        })
        .catch((error: any) => {
            if (
                typeof error.response === "undefined" ||
                !Object.prototype.hasOwnProperty.call(error.response, "data")
            ) {
                return;
            }

            if (
                Object.prototype.hasOwnProperty.call(
                    error.response.data,
                    "errors",
                )
            ) {
                const field = Object.keys(error.response.data.errors)[0];
                message.type = "error";
                message.message = error.response.data.errors[field][0];
            } else {
                message.type = "unauthenticated";
                message.message = error.response.data.message;
            }
        });
}
</script>
